export default function Contact() {
  // табы
  const tabsBtn = document.querySelectorAll('.contact-block-address .tabs-container .tab');

  if (tabsBtn) {
    tabsBtn.forEach(tab => {
      tab.addEventListener('click', function (e) {
        const parentSection = this.closest('section');
        const block = parentSection.querySelector('#' + this.dataset.tab);
        if (!block) {
          return;
        }
        const show = parentSection.querySelector('.show');
        if (show) {
          show.classList.remove('show');
        }
        parentSection.querySelector('.tab-active').classList.remove('tab-active');
        this.classList.add('tab-active');
        block.classList.add('show');
      });
    });
  }

}